const executeObjectFunctions = (obj, ...args) => {
	if (
		obj === null ||
		(typeof obj !== 'object' && typeof obj !== 'function')
	) {
		return obj;
	}

	if (Array.isArray(obj)) {
		return obj.map((item) => executeObjectFunctions(item, ...args));
	} else if (typeof obj === 'function') {
		return obj(...args); // Execute the function with provided arguments
	} else if (typeof obj === 'object') {
		const executedObj = {};
		Object.keys(obj).forEach((key) => {
			const value = obj[key];
			if (typeof value === 'function') {
				executedObj[key] = value(...args); // Execute the function with provided arguments
			} else {
				executedObj[key] = executeObjectFunctions(value, ...args); // Recursively process non-function values
			}
		});
		return executedObj;
	}

	return obj;
};

export default executeObjectFunctions;
